<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-sheet>
          <v-container fluid>
            <v-row>
              <v-col
                class="col_sectionExplorer"
                cols="2"
              >
                <v-list>
                  <v-list-item-group
                    v-model="sectionModel"
                    mandatory
                  >
                    <template v-for="(section, i) in sections">
                      <v-list-item
                        v-if="i < 2 || hasRight"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ section.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ $t(section.text) }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col
                class="col_section"
                cols="10"
              >
                <info-section v-if="sectionModel == 0" />
                <account-section v-if="sectionModel == 1" />
                <user-section v-if="sectionModel == 2 && hasRight" />
                <viewer-section v-if="sectionModel == 3 && hasRight" />
                <access-section v-if="sectionModel == 4 && hasRight" />
                <player-section v-if="sectionModel == 5 && hasRight" />
                <group-section v-if="sectionModel == 6 && hasRight" />
                <favourite-section v-if="sectionModel == 7 && hasRight" />
                <log-section v-if="sectionModel == 8 && hasRight" />
                <!--
                  <mail-transfer-section v-if="sectionModel == 9" />
                -->
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import infoSection from "./ProfilePage/InfoSection";
import accountSection from "./ProfilePage/AccountSection";
import userSection from "./ProfilePage/UserSection";
import playerSection from "./ProfilePage/PlayerSection";
import groupSection from "./ProfilePage/GroupSection";
import accessSection from "./ProfilePage/AccessSection";
import favouriteSection from "./ProfilePage/FavouriteSection";
import logSection from "./ProfilePage/LogSection";
import viewerSection from "./ProfilePage/ViewerSection";
//import mailTransferSection from "./ProfilePage/MailTransferSection";

export default {
  components: {
    accountSection,
    infoSection,
    userSection,
    playerSection,
    groupSection,
    accessSection,
    favouriteSection,
    logSection,
    viewerSection,
    //mailTransferSection
  },
  props: {
    sectionInitial: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      hasRight: this.$store.state.user.permissions.includes("8"),
      sectionCurrent: 0,
      sections: [
        {
          icon: "mdi-account-box",
          text: "profile.info",
        },
        {
          icon: "mdi-information-outline",
          text: "profile.account",
        },
        {
          icon: "mdi-account-multiple",
          text: "profile.users",
        },
        {
          icon: "mdi-eye",
          text: "profile.viewer",
        },
        {
          icon: "mdi-shield-lock-outline",
          text: "profile.access",
        },
        {
          icon: "mdi-monitor",
          text: "profile.players",
        },
        {
          icon: "mdi-monitor-multiple",
          text: "profile.groups",
        },
        {
          icon: "mdi-star-outline",
          text: "profile.favs",
        },
        {
          icon: "mdi-view-list",
          text: "profile.log",
        },
        /*,
          {
            icon: "mdi-email-send-outline",
            text: "profile.mail-transfer"
          }
          */
      ],
    };
  },
  computed: {
    sectionModel: {
      get: function () {
        return this.sectionCurrent;
      },
      set: function (val) {
        if (isNaN(val)) {
          this.sectionCurrent = 0;
        } else {
          this.sectionCurrent = parseInt(val);
        }
      },
    },
  },
  created() {
    document.title = this.$t("navbar.profile") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.profile"));
  },
  mounted() {
    this.changeSection(this.sectionInitial);
  },
  methods: {
    changeSection(val) {
      this.sectionModel = val;
    },
  },
};
</script>

<style>
.theme--dark .col_sectionExplorer {
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.theme--light .col_sectionExplorer {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.col_section {
  max-height: 75vh;
  overflow-y: auto;
}
</style>
